import { render, staticRenderFns } from "./CardOrder.vue?vue&type=template&id=3fa2adc9&scoped=true&"
import script from "./CardOrder.vue?vue&type=script&lang=js&"
export * from "./CardOrder.vue?vue&type=script&lang=js&"
import style0 from "./CardOrder.vue?vue&type=style&index=0&id=3fa2adc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa2adc9",
  null
  
)

export default component.exports